import React from 'react';
import { Phone, MessageCircle, Mail } from 'lucide-react';
import { companyInfo } from '../../data/mockData';

export const FooterContact = () => (
  <div className="footer-section">
    <h4>Contact</h4>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      <a href={`tel:${companyInfo.phone}`} className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <Phone size={15} /> {companyInfo.phone}
      </a>
      <a
        href={`https://wa.me/${companyInfo.whatsappRaw}`}
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link"
        style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
      >
        <MessageCircle size={15} /> {companyInfo.whatsapp}
      </a>
      <a href={`mailto:${companyInfo.email}`} className="footer-link" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <Mail size={15} /> {companyInfo.email}
      </a>
    </div>

    <div style={{ marginTop: '1rem', fontSize: '0.8rem', color: 'rgba(255,255,255,0.7)', lineHeight: 1.55 }}>
      <strong style={{ display: 'block', color: 'rgba(255,255,255,0.92)', marginBottom: '0.25rem' }}>
        Business Hours
      </strong>
      Mon – Fri: 9:00 AM – 6:00 PM<br />
      Sat: 9:00 AM – 2:00 PM<br />
      Sun: By Appointment
    </div>
  </div>
);
